import React from 'react'
import { ListGroupItem, Card, CardHeader, CardBody, ListGroup, } from 'reactstrap'
import forOwn from 'mout/object/forOwn'
import sortByPropText from '../../helpers/content/manageSets/sortByPropText'

/*
  ManageEducators

  <SchoolsCard
    districts={this.props.districts}
    schools={this.props.schools}
    key='SchoolsCard'
    selectedDistrict={this.props.selection.district}
    selectedSchool={this.props.selection.school}
    select={this.props.select}
    openModal={this.props.openModal}
    educators={this.props.educators}
    setForceExpanded={this.props.setForceExpanded}
    forceSchoolExpanded={this.props.setForceSchoolExpanded}
    permissionDistrict={permissionDistrict}
  />
*/

export default function SchoolsCard ({
  districts, schools, selectedDistrict, 
  selectedSchool, select, openModal, educators,
  setForceExpanded, forceSchoolExpanded, view,
  permissionDistrict, 
}) {
  console.log(districts, schools, selectedDistrict, 
    selectedSchool, select, openModal, educators,
    setForceExpanded, forceSchoolExpanded, view,
    permissionDistrict, )
  let schoolsCardBody = null

  if (selectedDistrict) {
    let schoolListGroupItems = []

    if ((!selectedSchool || forceSchoolExpanded) && permissionDistrict) {
      schoolListGroupItems.push(
        <ListGroupItem
          key='schoolListGroupItemAdd'
          onClick={() => openModal('addSchool')}
          className='m2clickable'
        >
          + Add School
        </ListGroupItem>
      )
    }

    const district = districts[selectedDistrict]

    if (district.schools && schools) {
      let schoolList = []
      forOwn(district.schools, (check, schoolId) => {
        if (check && schools[schoolId]) {
          schoolList.push(schools[schoolId])
        }
      })
      if (schoolList.length > 0) {
        const sortedSchoolList = sortByPropText(schoolList, 'name')
        sortedSchoolList.forEach((school) => {
          const active = school.id === selectedSchool
          if (active || !selectedSchool || forceSchoolExpanded) {
            schoolListGroupItems.push(
              <ListGroupItem
                key={`schoolListGroupItem${school.id}`}
                active={active}
                className={'m2clickable'}
                onClick={
                  active 
                  ? () => openModal(`record&id=${school.id}`) 
                  : () => select(school.id)
                }
              >
                {school.name}
                {active ? <i className="icon-magnifier icons ml-2"></i> : null}
              </ListGroupItem>
            )
          }
        })
      }
    }

    let districtAdminListGroupItems = []

    if (view !== 'students' && permissionDistrict) {
      if (!selectedSchool || forceSchoolExpanded) {
        districtAdminListGroupItems.push(
          <ListGroupItem
            key='districtAdminListGroupItemAdd'
            onClick={() => openModal('addDistrictAdmin')}
            className='m2clickable'
          >
            + Add District Admin
          </ListGroupItem>
        )
      }
  
  
      if (district.admins && educators) {
        let admins = []
        forOwn(district.admins, (check, adminId) => {
          if (check && educators[adminId]) {
            admins.push(educators[adminId])
          }
        })
        if (admins.length > 0) {
          const sortedAdmins = sortByPropText(admins, 'lastName')
          sortedAdmins.forEach((admin) => {
            if (!selectedSchool || forceSchoolExpanded) {
              districtAdminListGroupItems.push(
                <ListGroupItem
                  key={`districtAdminListGroupItem${admin.id}`}
                  className='m2clickable m2icon-hover'
                  onClick={() => openModal(`record&id=${admin.id}`)}
                >
                  {`${admin.firstName} ${admin.lastName}`} <i className="icon-magnifier icons ml-2"></i>
                </ListGroupItem> 
              )
            }
          })
        }
      }
    }
    
    const districtAdminListGroup = (
      <ListGroup className='mb-2'>
        {districtAdminListGroupItems}
      </ListGroup>
    )

    schoolsCardBody = (
      <CardBody>
        {view === 'students' ? null : districtAdminListGroup}
        <ListGroup>
          {schoolListGroupItems}
        </ListGroup>
      </CardBody>
    )
  }

  let icon = (
    <i 
      className="fa fa-minus-circle float-right m2clickable"
      onClick={() => setForceExpanded('forceSchoolExpanded', false)}  
    ></i>
  )
  if (selectedSchool && !forceSchoolExpanded) {
     icon = (
      <i 
        className="fa fa-plus-circle float-right m2clickable" 
        onClick={() => setForceExpanded('forceSchoolExpanded', true)}
      ></i>
    ) 
  } else if (!forceSchoolExpanded) {
    icon = <i className='fa fa-circle float-right'></i>
  }

  return (
    <Card>
      <CardHeader>
        {permissionDistrict ? icon : null} Schools
      </CardHeader>
      {schoolsCardBody}
    </Card>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/SchoolsCard.js